__turbopack_context__.v({
  "passport_thumbnail_carousel": "NYjA0W_passport_thumbnail_carousel",
  "splide__arrow": "NYjA0W_splide__arrow",
});
